import React from 'react';
import {
  IconEyeFull,
  IconGlasses,
  IconSun,
  IconDroplet,
  IconStar,
  IconWrench,
} from './Icons';

// Keys must match the lucide-react map in
// gs_optical_site/src/components/sections/ServicesGrid.tsx (ICONS const).
// Adding a key here without adding it there means the storefront falls back to <Glasses/>.
export const SERVICE_ICONS = [
  { key: 'eye', label: 'Œil', Icon: IconEyeFull },
  { key: 'glasses', label: 'Lunettes', Icon: IconGlasses },
  { key: 'sun', label: 'Soleil', Icon: IconSun },
  { key: 'drop', label: 'Goutte', Icon: IconDroplet },
  { key: 'star', label: 'Étoile', Icon: IconStar },
  { key: 'wrench', label: 'Clé', Icon: IconWrench },
];

const SERVICE_ICON_MAP = Object.fromEntries(SERVICE_ICONS.map((i) => [i.key, i]));

export function getServiceIcon(key) {
  return SERVICE_ICON_MAP[key] || null;
}

export default function IconPicker({ value, onChange, options = SERVICE_ICONS }) {
  return (
    <div className="icon-picker">
      {options.map(({ key, label, Icon }) => {
        const selected = value === key;
        return (
          <button
            key={key}
            type="button"
            className={`icon-picker__item${selected ? ' is-selected' : ''}`}
            onClick={() => onChange(selected ? '' : key)}
            title={label}
            aria-pressed={selected}
          >
            <Icon />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
